function SizeBox({w, h, ...props}) { // 마진 안쓰고 중간에 무머 놓을 때
    return(
      <div style={{width: `${w}px`, height: `${h}px`}}>
          {props.children}
      </div>
    );
}

export default SizeBox;